// Contact form API utilities
export interface ContactFormData {
  name: string;
  email: string;
  company?: string;
  teamSize?: string;
  subject: string;
  message: string;
  inquiryType: string;
  formLoadTime?: number; // For spam detection
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

/**
 * Submit contact form data to the API
 */
export async function submitContactForm(formData: ContactFormData): Promise<ContactFormResponse> {
  try {
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to submit contact form'
    };
  }
}
